<div class="scrollbar app px-0">
  <div class="card-header" translate>lblCustomerWaiting</div>
  <div class="pad15 pt-0">
    <form [formGroup]="occasionForm" (ngSubmit)="AddOccasionDetails()">
      <div class="mt-2 p-0">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-xl-9">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                <label for="name" translate>lblOccasionName <span class="text-danger">*</span></label>
                <div class="lbl-info">
                  <input formControlName="occasionname" class="form-control mb-2" maxlength="30"
                    [ngClass]="{'is-invalid': (cpf.occasionname.touched || cpf.occasionname.dirty) && cpf.occasionname.errors}"
                    placeholder="Enter Occasion Name" [readonly]="isReadOnly">
                  <div *ngIf="(cpf.occasionname.touched || cpf.occasionname.dirty) && cpf.occasionname.errors?.required"
                    class="help-block mt-1 text-danger" translate>lblOccasionNameRequired</div>
                </div>
              </div>

              <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                <label for="startDate" translate>lblStartDate <span class="text-danger">*</span></label>
                <div class="date" *ngIf="!isStartDateLocked">
                  <input class="form-control datePicker width100force mb-2" appAfDatepicker [startDate]="minDate"
                    [dateTime]="false" placeholder="{{ 'lblEnterStartDate' | translate }}" [disableNextMonthDates]="true"
                    formControlName="startdate" [(ngModel)]="startdate" type="text" autocomplete="off">
                  <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  <div *ngIf="(cpf.startdate.touched || cpf.startdate.dirty) && cpf.startdate.errors?.required"
                    class="help-block mt-1 text-danger" translate>lblStartDateRequired</div>
                </div>
                <div class="lbl-info" *ngIf="isStartDateLocked">
                  <input formControlName="startdate" class="form-control mb-2" [(ngModel)]="startdate" [readonly]="true">
                </div>
              </div>

              <div class="col-md-6 col-lg-6 col-xl-4 af-form-group">
                <label for="endDate" translate>lblEndDate <span class="text-danger">*</span></label>
                <div class="date" *ngIf="!isReadOnly">
                  <input class="form-control datePicker mb-2" appAfDatepicker [startDate]="startdate || minDate"
                    [dateTime]="false" placeholder="{{ 'lblEnterEndDate' | translate }}" [disableNextMonthDates]="true"
                    formControlName="enddate" [(ngModel)]="enddate" type="text" autocomplete="off">
                  <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  <div *ngIf="(cpf.enddate.touched || cpf.enddate.dirty) && cpf.enddate.errors?.required"
                    class="help-block mt-1 text-danger" translate>lblEndDateRequired</div>
                </div>
                <div class="lbl-info" *ngIf="isReadOnly">
                  <input formControlName="enddate" class="form-control mb-2" [(ngModel)]="enddate" [readonly]="true">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-3 af-form-group pt-20">
            <button type="submit" class="btn btn-primary mb-2" [disabled]="isReadOnly" translate>lblSave</button>
            <button type="button" class="btn btn-primary ml-2 mb-2" (click)="OnClear()" translate>lblAddOccasion</button>
            <button type="button" class="btn btn-primary ml-2 mb-2" [hidden]="!selectedOccasion || isReadOnly"
              (click)="OnDelete()" translate>lblDelete</button>
          </div>
        </div>
      </div>
    </form>

    <div class="p-0">
      <div class="row">
        <div class="col-md-6 col-lg-6 col-xl-3 af-form-group" *ngFor="let item of occasionList">
          <label class="mr10"><input name="options" type="radio" [value]="item.id" (change)="ChangeOccasion()"
              [(ngModel)]="selectedRadioButton"> {{item.occasionName}}</label>
        </div>
      </div>
    </div>

    <div class="add-slot-panel" *ngIf="selectedOccasion && !isReadOnly">
      <div>
        <label translate>lblDay</label>
        <div class="add-slot-control">
          <button type="button" *ngFor="let day of days" class="btn btn-sm day-toggle mr-1"
            [ngClass]="day.isSelected ? 'btn-primary' : 'btn-outline-secondary'" [disabled]="!day.isActive || day.isClosed"
            (click)="day.isSelected = !day.isSelected">{{ day.dayText | slice:0:3 }}</button>
        </div>
      </div>
      <div>
        <label translate>lblSlotFrom</label>
        <div class="add-slot-control date">
          <ngb-timepicker [(ngModel)]="slotFrom" [minuteStep]="15"></ngb-timepicker>
        </div>
      </div>
      <div>
        <label translate>lblSlotTill</label>
        <div class="add-slot-control date">
          <ngb-timepicker [(ngModel)]="slotTill" [minuteStep]="15"></ngb-timepicker>
        </div>
      </div>
      <div>
        <label>&nbsp;</label>
        <div class="add-slot-control">
          <button type="button" class="btn btn-primary" [disabled]="!hasSelectedDay" (click)="onTimeSlotAdd()">
            <em class="fa fa-plus mr-1"></em><span translate>lblAdd</span>
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive tableMx-15 form-check pl-0" *ngIf="selectedOccasion">
      <table class="tablest1">
        <thead>
          <tr>
            <th style="width: 8%" class="text-center" scope="col" translate>lblIsActive</th>
            <th style="width: 10%" scope="col" translate>lblDay</th>
            <th style="width: 13%" scope="col" translate>lblDealerShiftDetails</th>
            <th style="width: 13%" scope="col" translate>lblShiftTimings</th>
            <th scope="col" translate>lblCustomerWaiting</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let day of days" [ngClass]="{'day-off': day.isClosed || !day.isActive}">
            <td class="text-center">
              <div class="custom-checkbox">
                <input type="checkbox" [ngModel]="day.isActive && !day.isClosed" [disabled]="isReadOnly || day.isClosed"
                  (ngModelChange)="day.isActive = $event; isUpdatedValue = true">
              </div>
            </td>
            <td>{{ day.dayText }}</td>
            <td>{{ day.dealerShiftDetails | translate }}</td>
            <td>{{ day.mechanicShiftDetails | translate }}</td>
            <td>
              <div class="d-flex flex-wrap">
                <span *ngIf="day.slots.length === 0">-</span>
                <div *ngFor="let slot of day.slots; let i = index" class="time-slot"
                  [ngClass]="slot.id === 0 ? 'time-slot-new' : 'time-slot-existing'">
                  <span>{{ slot.startTime }} - {{ slot.endTime }}</span>
                  <em *ngIf="slot.isLocked" class="fas fa-lock" ngbTooltip="{{ 'lblMechanicCWSlotLocked' | translate }}"
                    container="body" tooltipClass="custom-revert"></em>
                  <em *ngIf="!slot.isLocked && !isReadOnly" class="far fa-trash-alt"
                    ngbTooltip="{{ 'lblDelete' | translate }}" container="body" tooltipClass="custom-revert"
                    (click)="onTimeSlotDelete(day, i)"></em>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="p-3 bg-light pp-footer-top-brdr">
  <div class="row">
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
      <button class="btn btn-primary btn-lg" (click)="onSaveChanges(false)" [disabled]="!isUpdatedValue || isReadOnly"
        translate>lblSaveChanges</button>
      <button class="btn btn-primary ml-2 btn-lg" (click)="onSaveChanges(true)" [disabled]="!isUpdatedValue || isReadOnly"
        translate>lblSaveAndClose</button>
      <a (click)="OnClose()" class="btn btn-secondary ml-2 btn-lg" translate>lblBack</a>
    </div>
  </div>
</div>
